module.exports = __webpack_public_path__ + "assets/just-eat-mobile-logo-f95c67.svg";